import {
  ENQUEUE_CONTRACT_EXPORT_SUCCESS
} from '../actions/contracts'

export default function (state = {}, action) {
  switch (action.type) {
    case ENQUEUE_CONTRACT_EXPORT_SUCCESS:
      return {
        ...state,
        [action.payload.contractId]: {
          ...state[action.payload.contractId],
          exporting: true
        }
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/contracts.js